import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import styled from "@emotion/styled";
import { Box, InputBase, TablePagination } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export default function SubscriptionsTable({ rows, header, setSearch }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(4);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <Paper sx={{ width: "100%", margin: 0, position: "relative" }}>
      <Paper
        component="form"
        sx={{
          p: "10px 4px",
          display: "flex",
          boxShadow: "none",
          alignItems: "center",
          justifyContent:"center"
        }}
      >
        <Box
          sx={{
            border: "1px solid #D5D6D7",
            borderRadius: 3,
            flex: 1,
            display: "flex",
            justifyContent: "space-between",
            marginRight: 5,
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search Subscriptions by id, title or status"
            inputProps={{ "aria-label": "search Subs" }}
            onChange={(e) => setSearch(e.target.value)}
          />
          <IconButton
            type="button"
            sx={{ p: "10px", color: "#D5D6D7" }}
            aria-label="search"
          >
            <SearchIcon />
          </IconButton>
        </Box>
      </Paper>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {header.map((i) => (
                <StyledTableCell key={i}>{i}</StyledTableCell>
              ))}
              {/* <StyledTableCell align="center">Start</StyledTableCell>
            <StyledTableCell align="center">End</StyledTableCell>
            <StyledTableCell align="center">Full Day</StyledTableCell>
            <StyledTableCell align="center">Off</StyledTableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length>0?
            rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow
                  key={row[0]}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>{row[0]}</TableCell>
                  <TableCell align="left">{row[1]}</TableCell>
                  <TableCell
                    sx={{ color: row[2] == "active" ? "green" : "red" }}
                    align="left"
                  >
                    {row[2]}
                  </TableCell>
                  <TableCell align="left">{row[3]}</TableCell>
                  <TableCell align="left">{row[4]}</TableCell>
                  <TableCell align="left">{row[5]}</TableCell>
                </TableRow>
              )) : <div style={{
                margin: 10,
                fontSize: 24,
              }}>There is no match for this search</div>}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
